import React from 'react';

const StatusBar = ({ status, text }: any) => {
    const stat = status as boolean;

    return <div className={`status-bar ${stat ? 'on' : 'off'}`}>{text}</div>;
};

export default StatusBar;
